export const FORMAT_TYPES = {
  SERIES: "0",
  FACE_TO_FACE: "1",
  COMMUNITY_OF_LEARNERS: "2",
  ONLINE_SYNCH: "3",
  ONLINE_ASYNCH: "4",
  ONLINE_HYBRID: "5",
  ONLINE_BRIGHTSPACE: "6",
  ONLINE_INSIGHT: "7",
  CAREER_TECH: "8",
  ONLINE_COX_CAMPUS: "9",
  ONLINE_OH_TRAIN: "10",
};
